import { createContext } from "react"


export const tokenContext = createContext({
  token: "",
  expiration: 0,
  updateToken: (token: string, expiration: number) => { },
})